import React from 'react';
import ATag from 'antd-mobile/lib/tag';



export default class Tag extends ATag {}